import axios from 'axios';

let baseUrl = '/chatbot-api';
if(process.env.NODE_ENV ===  'development'){
  baseUrl = 'https://developer-portal.dev.spcgrafeno.be/chatbot-api';
}

const askQuestion = async (question) => {
  const url = `${baseUrl}/ask`;

  try {
    const response = await axios.post(url, JSON.stringify({ question }), {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default askQuestion; 
